import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export default definePreset(Aura, {
  primitive: {
    font: {
      family: '"carbona-variable", sans-serif',
    },
    color: {
      white: '#FFFFFF',
      black: '#000000',
      blue: '#054561',
      desaturatedBlue: '#598392',
      beige: '#EFEEE0',
      green: '#ADE3BC',
      darkGreen: '#92D5A6',
      red: '#FD656C',
      lightRed: '#FFB5B5',
      lightRedBis: '#FF999E',
      pink: '#EABED1',
      darkPink: '#E8CAD7',
      orange: '#FFC28C',
      darkOrange: '#F7CB95',
      turquoise: '#82CCD9',
      darkTurquoise: '#91BDCC',
      lightGrey: '#F4F4F5',
      grey: '#E0DFDF',
      darkGrey: '#CBCBCB',
      mouseoverBlue: '#7A94B5',
      mouseoverGrey: '#BCBCBC',
      yellow: '#EFEEE1',
      mutedBlueGrey: '#9FADBF',
      slate: '#64748B',
      disabled: {
        blue: 'rgba(5, 69, 97, 0.6)',
        grey: 'rgba(224, 223, 223, 0.6)',
        white: 'rgba(255, 255, 255, 0.6)',
      },
    },
    rule: {
      accordion: {
        background: '{color.beige}',
      },
    },
    variable: {
      height: '24.5px',
    },
    leftMenuWidth: '250px',
    heightLine: '60px',
    form: {
      field: {
        large: {
          width: '13vw',
        },
      },
    },
  },
  semantic: {
    colorScheme: {
      light: {
        red: {
          500: '{color.red}',
          600: '{color.lightRed}',
        },
        primary: {
          50: '{blue.50}',
          100: '{color.blue}',
          200: '{color.blue}',
          500: '{color.blue}',
          hover: {
            color: '{color.desaturatedBlue}',
          },
          active: {
            color: '{color.desaturatedBlue}',
          },
        },
        text: {
          color: '{color.blue}',
        },
        highlight: {
          color: '{color.blue}',
          background: '{color.lightGrey}',
        },
        form: {
          field: {
            color: '{color.blue}',
            border: {
              color: '{color.desaturatedBlue}',
            },
            disabled: {
              color: '{color.disabled.blue}',
              background: '{color.disabled.white}',
            },
            focus: {
              ring: {
                color: '{color.desaturatedBlue}',
              },
              border: {
                color: '{color.desaturatedBlue}',
              },
            },
          },
        },
      },
    },
  },
  components: {
    datatable: {
      body: {
        cell: {
          padding: '.5rem .75rem',
        },
      },
      header: {
        cell: {
          padding: '.5rem .75rem',
        },
      },
      row: {
        hoverBackground: '{color.red}',
      },
      colorScheme: {
        light: {
          header: {
            cell: {
              padding: '.5rem .75rem',
            },
          },
          row: {
            selected: {
              background: '{color.lightGrey}',
              color: '{text.color}',
            },
          },
        },
      },
    },
    select: {
      colorScheme: {
        light: {
          option: {
            selected: {
              color: '{text.color}',
              focus: {
                color: '{color.white}',
              },
            },
          },
        },
      },
    },
    accordion: {
      panel: {
        border: {
          width: '{borderRadius.none}',
        },
      },
      content: {
        padding: '{borderRadius.none}',
      },
      colorScheme: {
        light: {
          header: {
            color: '{text.color}',
            background: '{rule.accordion.background}',
            hover: {
              background: '{rule.accordion.background}',
              color: 'none',
            },
            active: {
              background: '{rule.accordion.background}',
              hover: {
                background: '{rule.accordion.background}',
              },
            },
          },
        },
      },
    },
    checkbox: {
      height: '16px',
      width: '16px',
      icon: {
        size: '10px',
      },
      colorScheme: {
        light: {
          checked: {
            background: '{color.blue}',
          },
          hover: {
            background: '{color.desaturatedBlue}',
            border: {
              color: '{color.desaturatedBlue}',
            },
          },
          icon: {
            disabled: {
              color: '{color.white}',
            },
            checked: {
              hover: {
                color: '{color.white}',
              },
            },
          },
        },
      },
    },
    menu: {
      item: {
        content: {
          padding: '10px 20px 10px 20px',
        },
      },
    },
    textarea: {
      colorScheme: {
        light: {
          border: {
            color: '{color.grey}',
          },
        },
      },
    },
    button: {
      colorScheme: {
        light: {
          primary: {
            hover: {
              color: '{color.white}',
            },
          },
          secondary: {
            background: '{color.slate}',
            color: '{color.white}',
          },
          success: {
            background: '{color.darkGreen}',
            color: '{color.white}',
            border: {
              color: '{color.darkGreen}',
            },
            hover: {
              background: '{color.darkGreen}',
              border: {
                color: '{color.darkGreen}',
              },
            },
          },
          text: {
            info: {
              color: '{text.color}',
            },
          },
        },
      },
      extend: {
        primarydanger: {
          hover: {
            color: '{color.red}',
            background: '{color.lightRed}',
            border: {
              color: '{color.lightRed}',
            },
          },
        },
      },
    },
  },
});
